import type { ReservationCheckOutEarlyEvent } from "@@/shared/reservations/events/resevation-check-out-early.event";
import { reservationCheckOutEarlyEventZodSchema } from "@@/shared/reservations/events/resevation-check-out-early.event";

type ReservationEvent = ReservationCheckOutEarlyEvent;

type ReservationType = ReservationEvent["type"];

// const reservationEventZodSchema: z.ZodSchema<ReservationEvent> = z.union([
//     reservationCheckOutEarlyEventZodSchema,
// ]);
//Change to
const reservationEventZodSchema = reservationCheckOutEarlyEventZodSchema;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isReservation = (event: any): event is ReservationEvent => {
    return event?._type === "Reservation_EVENT";
};
export { isReservation, reservationEventZodSchema };
export type { ReservationEvent, ReservationType };
